<template>
  <main>
    <header-view>{{ $t('assessment.title') }}</header-view>

    <!-- 提高项目对比图 -->
    <waterfall-card
        :class="['card-first', { more }]"
        v-if="list.length > 0"
        :title="$t('assessment.improvementProjectChart')"
        :list="list"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <!-- 有待提高项目比对图 -->
    <waterfall-card
        class="card"
        v-if="more && awaitList.length > 0"
        :title="$t('assessment.awaitImprovementChart')"
        :list="awaitList"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <waterfall-card
        class="card-last"
        v-if="more && dynamics.length > 0"
        :title="$t('assessment.dynamicComparisonChart')"
        :list="dynamics"
        labelKey="item_dict_name"
        :valueKey="stackValueKey"
        :colorKey="stackColorKey"
        stack="diff"
        tips
        @tip="interpret = true"
    ></waterfall-card>

    <div
        v-if="!more"
        class="more-btn"
    >
      <div class="btn" @click="more = true">{{ $t('actions.viewMore') }}</div>
    </div>

    <!-- 饮食建议 -->
    <diet-card :useful="diets.useful" :useless="diets.useless"></diet-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" :title="$t('assessment.interpretationTitle')">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>
  </main>
</template>

<script>
  import HeaderView from "@/components/HeaderView";
  import WaterfallCard from "@/components/WaterfallCard";
  import DietCard from "@/components/DietCard";
  import {getReportInfoCompare} from "../net/api";
  import DialogView from "../components/DialogView";

  export default {
    name: "Assess",
    components: {DialogView, DietCard, WaterfallCard, HeaderView},

    data() {
      return {
        packageNo: '',
        checkcode: '',
        rand: '',

        more: false,

        stackColorKey: ['color_old', 'color'],

        // 饮食建议
        diets: {
          useful: [],
          useless: []
        },

        // 提高项目对比图
        list: [],
        // 有待提高项目对比图
        awaitList: [],
        // 动态对比图
        dynamics: [],

        // 报告等级列表
        levels: [],
        // 解读说明弹窗
        interpret: false
      }
    },

    computed: {
      // 通用态图列表数据关联项
      valueKey() {
        return {
          av_old: this.$t('assessment.lastDetection'),
          av: this.$t('assessment.currentDetection'),
        };
      },

      stackValueKey() {
        return [{
          one_old: this.$t('assessment.lastInitialValue'),
          two_old: this.$t('assessment.lastFinalValue'),
        }, {
          one: this.$t('assessment.currentInitialValue'),
          two: this.$t('assessment.currentFinalValue'),
        }];
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        // 获取报告数据
        getReportInfoCompare({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode
        }).then((data) => {
          this.levels = data.colorData;
          this.list = data.itemTiGao;
          this.awaitList = data.itemNoTiGao;
          this.dynamics = data.dongTaiDuiBiTu;
          this.diets.useful = data.tolerantFood;
          this.diets.useless = data.noTolerantFood;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-first {
    padding-bottom: 130px;

    &.more {
      padding-bottom: 20px;
      margin-bottom: 0;
      border-radius: 20px 20px 0 0;
    }
  }
  .card {
    border-radius: 0 0 0 0;
    padding-bottom: 20px;
    margin-bottom: 0;
  }
  .card-last {
    border-radius: 0 0 20px 20px;
  }

  .more-btn {
    position: absolute;
    width: 100%;
    left: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;

    .btn {
      position: absolute;
      top: -110px;
      width: 160px;
      height: 50px;
      background: #EDF4FF;
      border-radius: 25px;
      font-size: 24px;
      color: #6CA0EC;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>